var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{staticClass:"my-page themeable",attrs:{"total":_vm.totalCount,"current":_vm.setCurrentPage,"page-size-opts":_vm.pageArr,"show-total":"","show-elevator":"","page-size":_vm.length,"placement":"top","show-sizer":""},on:{"update:current":function($event){_vm.setCurrentPage=$event},"on-change":_vm.changePage,"on-page-size-change":_vm.pageSizeChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/common/myPage.vue